import { MessageType, formatMessage } from 'utils/Message';
import { s3KeyToUrl } from 'utils/images';
import fetchAPI from 'utils/fetchAPI';
import queryString from 'query-string';

export const broadcastToFollowers = ({
  companyId,
  channelId,
  message,
  type,
  segmentIds,
  followerIDs,
  showOnNewsfeed,
}) => (dispatch, getState) =>
  new Promise((resolve, reject) => {
    const token = getState().users.token;

    // We call this function primarily to throw Error if segmentIds is empty.
    segmentIdsToSegmentId(segmentIds); // eslint-disable-line no-use-before-define

    formatMessage({ type, message, token })
      .then(formattedMessage => {
        fetchAPI({
          endpoint: `/companies/${companyId}/channel/${channelId}/message`,
          method: 'POST',
          version: '1.2',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({
            ...formattedMessage,
            follower_ids: followerIDs,
            show_on_news_feed: showOnNewsfeed,
          }),
        }).then(res => {
          if (res.ok) {
            return resolve();
          }
          return reject();
        });
      })
      .catch(e => reject(e));
  });

export const fetchChannelSegments = ({ channelId }) => (dispatch, getState) =>
  new Promise((resolve, reject) => {
    const token = getState().users.token;

    fetchAPI({
      endpoint: `/channels/${channelId}/segments`,
      version: '1.2',
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    })
      .then(res => res.json())
      .then(json => {
        resolve(json.segments);
      });
  });

export const fetchChannelSegmentsMembers = ({
  channelId,
  segmentId,
  count,
  offset,
}) => (dispatch, getState) =>
  new Promise((resolve, reject) => {
    const token = getState().users.token;

    let maybeQs = '';
    if (count || offset) {
      const qs = queryString.stringify({ count, offset });
      maybeQs = `?${qs}`;
    }

    fetchAPI({
      endpoint: `/channels/${channelId}/segments/${segmentId}/members${maybeQs}`,
      version: '1.2',
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    })
      .then(res => res.json())
      .then(json => {
        resolve(json.members);
      });
  });

/**
 * WARNING BRITTLE: should fix on backend.
 * So backend only accepts 1 segment_id. If none is sent, it's assumed user wants to send to all.
 */
function segmentIdsToSegmentId(segmentIds) {
  const len = segmentIds.length;
  if (len === 0) {
    throw new Error('need to have some recipients');
  } else if (len === 1) {
    return +segmentIds[0];
  } else if (len === 2) {
    return null;
  } else {
    throw new Error('we dont handle sending more than 2 segments right now.');
  }
}

function formattedMessageToNewBroadcastFormat(
  formattedMessage,
  type,
  segmentId
) {
  let dataBody = {};
  if (segmentId) {
    dataBody = Object.assign(dataBody, { segment_id: segmentId });
  }
  if (type === MessageType.IMAGE) {
    const url = s3KeyToUrl(formattedMessage.body);
    dataBody = Object.assign(dataBody, { img: { url } });
  } else if (type === MessageType.PDF) {
    const { name, url, bytes } = JSON.parse(formattedMessage.body);
    dataBody = Object.assign(dataBody, {
      pdf: {
        name,
        url,
        bytes,
      },
    });
  } else {
    dataBody = Object.assign(dataBody, { body: formattedMessage.body });
  }
  return dataBody;
}

export const fetchChannelSend = ({
  channelId,
  segmentIds,
  body,
  type,
  followerIDs,
  excludeEmails,
}) => (dispatch, getState) =>
  new Promise((resolve, reject) => {
    const token = getState().users.token;

    formatMessage({ type, message: body, token }).then(formattedMessage => {
      const segmentId = segmentIdsToSegmentId(segmentIds);

      const dataBody = formattedMessageToNewBroadcastFormat(
        formattedMessage,
        type,
        segmentId
      );

      fetchAPI({
        endpoint: `/channels/${channelId}/send`,
        version: '1.2',
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          ...dataBody,
          follower_ids: followerIDs,
          exclude_emails: excludeEmails,
        }),
      }).then(res => {
        if (res.ok) {
          resolve();
        } else {
          reject();
        }
      });
    });
  });

export const fetchPostChannelSubscribers = ({
  channelId,
  emails,
  followerIDs,
  excludeEmails,
}) => (dispatch, getState) =>
  new Promise((resolve, reject) => {
    const token = getState().users.token;

    if (!emails.length) {
      resolve();
    }

    fetchAPI({
      endpoint: `/channels/${channelId}/subscribers`,
      version: '1.2',
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({
        email_address: emails.filter(email => !excludeEmails.includes(email)),
        follower_ids: followerIDs,
        exclude_emails: excludeEmails,
      }),
    }).then(res => {
      if (res.ok) {
        resolve();
      } else {
        reject();
      }
    });
  });

export const fetchChannelSubscribers = ({ channelId }) => (
  dispatch,
  getState
) =>
  new Promise((resolve, reject) => {
    const token = getState().users.token;

    fetchAPI({
      endpoint: `/channels/${channelId}/subscribe`,
      version: '1.2',
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    })
      .then(res => res.json())
      .then(json => {
        resolve(json.items);
      });
  });



// WEBPACK FOOTER //
// ./app/actions/BroadcastActionCreator.js